import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <header className="w-full bg-cream px-5 pb-12 pt-8 sm:px-6 sm:pb-16 sm:pt-12" data-id="element-131" data-mp="eiv4wuw1x6js">
      <div className="mx-auto w-full max-w-3xl text-center" data-id="element-132" data-mp="9k0ep7vr8fpn">
        <p className="font-display text-lg font-bold tracking-tight text-ofm-700 sm:text-xl" data-id="element-133" data-mp="9igvp9iprqk6">
          Dra. <span className="text-ofm-900" data-id="element-134" data-mp="4jvx1ej41exu">Karito</span>
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mt-6 font-display text-[30px] font-extrabold leading-[1.12] tracking-tight text-ofm-900 sm:text-[44px] md:text-5xl" data-id="element-135" data-mp="128yysajftrxl">
          Aprende a elegir el aparato funcional correcto para cada paciente
          infantil siguiendo un sistema de diagnóstico paso a paso que{' '}
          <span className="italic text-ofm-600" data-id="element-136" data-mp="382ffjpbzl6fg">
            elimina las decisiones por intuición
          </span>
          .
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-ofm-900/70 sm:text-lg" data-id="element-137" data-mp="3j9u06x1wdkkr">
          Descubre cómo identificar la verdadera causa de la maloclusión, construir
          un diagnóstico funcional sólido y justificar cada decisión clínica con
          mayor seguridad y confianza desde la primera consulta.
        </motion.p>

        <p className="mx-auto mt-4 max-w-xl text-[13px] font-semibold text-ofm-700 sm:text-[15px]" data-id="element-138" data-mp="35aax4iny0zfb">
          Más de 1.200 odontólogos ya utilizan el Sistema de Decisión Clínica OFM.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mt-8" data-id="element-139" data-mp="2vjg50xo0n5ly">
          <img src="https://cdn.magicpatterns.com/uploads/ifuNFXB4wxGKpMwgwdLuUo/reparaciones_mockup_sin_fondo.png" alt="Los 6 tomos del Sistema de Decisión Clínica OFM en versión digital para computadora, tablet y móvil" className="mx-auto w-full max-w-[520px]" loading="eager" data-id="element-140" data-mp="2ljz38rbvxbv9" />
        </motion.div>

        <div className="mt-8" data-id="element-141" data-mp="ddwx91783qe1">
          <CTAButton label="🦷 QUIERO EL SISTEMA OFM AHORA" subline="Descarga inmediata • Pago único • Acceso de por vida • Garantía de 7 días" data-id="element-142" data-mp="deq92gl1h631" />
        </div>
        <div id="cta-trigger" aria-hidden="true" className="h-px w-full" data-id="element-143" data-mp="16342sk53hg8s" />
      </div>
    </header>;
}